export * from './equipment-edit.component';
export * from './equipment-edit.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-edit/index.ts